webpackJsonp([244398686755325],{

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrderStatusPage = function OrderStatusPage() {
	  return _react2.default.createElement(
	    _components.PageWrapper,
	    { title: 'Check Order Status' },
	    _react2.default.createElement(
	      'div',
	      { className: 'contentPage' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12' },
	          _react2.default.createElement(_components.OrderStatus, null)
	        )
	      )
	    )
	  );
	};
	
	exports.default = OrderStatusPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-order-status-js-74d85259a9cf58527e76.js